module.exports = __webpack_public_path__ + "static/media/digita-logo-hybriditv.f0591a41.svg";